export default __webpack_public_path__ + "static/media/three.ff51b80f.svg";